import { render, staticRenderFns } from "./crm.vue?vue&type=template&id=14c62d92&scoped=true"
import script from "./crm.vue?vue&type=script&lang=js"
export * from "./crm.vue?vue&type=script&lang=js"
import style0 from "./crm.vue?vue&type=style&index=0&id=14c62d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c62d92",
  null
  
)

export default component.exports